export const ApplicationRoles = {
    AddGroup: process.env.REACT_APP_GROUPS_ADDGROUP!,
    EditGroup: process.env.REACT_APP_GROUPS_EDITGROUP!,
    AdminGroup: process.env.REACT_APP_GROUPS_ADMINGROUP!,
    FinanceGroup: process.env.REACT_APP_GROUPS_FINANCEGROUP!
}


export const ApplicationCache = "86b45253c47145e250cbf24e783be59a8d7cdbc9";
